module.exports = __webpack_public_path__ + "media/images/proof_links/colored/flickr-969a21da1ac4c4371f18d331df0e18ee.svg";